import React from 'react'
import Decimal from 'decimal.js'
import lang from '@/lang'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import { formatCurrency } from '@/modules/_helpers/formatCurrency'
import InfoItem from '@/modules/base/components/info/info-item'
import { transactionTypes } from '@/modules/base/util/constants'
import { useNavigate } from 'react-router'

const BankTransferInfo = (props) => {
  const { transaction } = props
  const classes = useStyles({ priceTotal: transaction?.priceTotal })
  const isCreditNote = transaction.type === transactionTypes.TRANSACTION_TYPE_CREDIT_NOTE
  const navigate = useNavigate()

  const onCustomerClick = () => {
    const { customerId, supplierId } = transaction
    if (customerId) navigate(`/customer/${customerId}`)
    else navigate(`/supplier/${supplierId}`)
  }

  return (
    <>
      <div className={classes.container}>
        <div>
          <div className={classes.customerTitle}>{lang.payments.bankTransferDrawer.bankTransferForm[isCreditNote ? 'customer' : 'supplierCustomer']}</div>
          <div className={classes.customerName} onClick={onCustomerClick}>{transaction?.payee || transaction?.customerData?.name || ''}</div>
          <InfoItem
            infoItem={{ label: lang.payments.paymentDrawer[isCreditNote ? 'creditNote' : 'expense'].number, value: transaction.receiptNumber || transaction.number }}
            className={classes.infoItem}
            keepCase
            classNameLabel={classes.infoItemLabel} />
        </div>
        <div className={classes.priceRow}>
          <InfoItem
            infoItem={{ label: lang.payments.paymentDrawer.openAmount, value: formatCurrency(new Decimal(transaction?.outstandingAmount).abs().toNumber()) }}
            classNameValue={classes.price}
            keepCase
            classNameLabel={classes.infoItemLabel} />
        </div>
      </div>
      <div className={classes.line} />
    </>
  )
}

const useStyles = makeStyles((theme) => ({
  customerTitle: {
    color: theme.darkerGrey,
  },
  infoItemLabel: {
    fontSize: 14,
  },
  infoItem: {
    flexDirection: 'row',
    gap: 5,
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  priceRow: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: 'fit-content',
    gap: '20px',
  },
  price: {
    color: theme.red,
    fontSize: '28px',
    letterSpacing: 0.56,
  },
  customerName: {
    color: theme.primary,
    fontSize: theme.fontSizes.smedium,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  line: {
    width: '100%',
    height: '1px',
    margin: '15px 0px',
    backgroundColor: theme.borderColor,
  },
}))

BankTransferInfo.propTypes = {
  transaction: PropTypes.object.isRequired,
}

export default BankTransferInfo
